import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import "./muiStepper.scss";
import { Col, Container, Row } from "react-bootstrap";

const BilateralStepper = ({
  data,
  innerStep,
  formName,
  activeOuterStep,
  totalSteps,
  cart,
}) => {
  
  let formatPrice = (price) => Number(price).toFixed(2);

  let cartTotal = (cart = []) => {
    let total = 0;
    cart.forEach((item) => {
      if (item.name == "From Cast") {
        item.name = "Create Electronic Shape";
      }
      if (item.quantity > 0 && item.price > 0) {
        total += item.price * item.quantity;
      }
    });

    return total;
  }

  let cartWithIndex = Object.groupBy(cart, ({formIndex}) => formIndex);
  const formIndexedCart = Object.values(cartWithIndex);

  return (
    <div className="muiStepper">
      <Box className="stepperWrapper">
        <Box className="muiStepper">
          <div className="formName">
            <p>Order Form</p>
            <h4>{formName}</h4>
          </div>
          <div className="stepperSteps">
            <Stepper
              activeStep={activeOuterStep}
              orientation="vertical"
              className="willow-wood-stepper"
            >
              {data.map((label, index) => (
                <Step key={label?.id}>
                  <StepLabel>{label?.name}</StepLabel>
                  {activeOuterStep === index &&
                    label.innerSteps?.length > 0 && (
                      <>
                        <div className="innerStepper">
                          <Stepper
                            activeStep={innerStep}
                            orientation="vertical"
                          >
                            {label?.innerSteps.map((substep) => (
                              <Step key={`innerStep-${substep.id}`}>
                                <StepLabel className="subStep">
                                  {substep?.name}
                                </StepLabel>
                              </Step>
                            ))}
                          </Stepper>
                        </div>
                      </>
                    )}
                </Step>
              ))}
            </Stepper>

            <div className="mobleSteps">
              <p>
                Step {`0${activeOuterStep + 1}`}/{`0${typeof totalSteps === 'function' ? totalSteps() : totalSteps}`}
              </p>
            </div>
          </div>
        </Box>
        <Box sx={{ flex: "2", padding: 2 }} className="right-content">
          <>
            <div className="stepperContent">
              {data[activeOuterStep]?.formContent}
            </div>
          </>
        </Box>

        {cart.length > 0 &&
          <Box sx={{ flex: "none", padding: 0 }} className="right-content">
            <Box className="stepperWrapper">
              <Box className="muiStepper">
                <Container className="formName" fluid="true" style={{ width: "200px", "paddingBottom": "90px" }}>
                  <Row><h4>Cart</h4></Row>
                  <br></br>

                  {formIndexedCart.map((formIndex, index) => {
                    return (<div key={index}>

                      {formIndex !== undefined ?
                        <div className={index !== 0 ? "pt-4" : ""}>
                          {formIndex[0]?.serialNumber ?
                            <div className="row"><h4 className="mt-0">Serial Number: {formIndex[0]?.serialNumber}</h4></div> : <></>}

                          {formIndex[0]?.footSide ?
                            <div className="row"><h4 className="mt-0">Side: {formIndex[0]?.footSide}</h4></div> : <></>}

                          {formIndex.map((item, i) => {
                            if (item.quantity > 0 && item.name) {
                              return (<Row key={i}>
                                <Col lg="6" sm="1">
                                  <Row><b>{item.name}:</b></Row>
                                  <Row><p>({item.partNumber})</p></Row>
                                </Col>
                                <Col></Col>
                                <Col>
                                  <Row>{item.quantity}x</Row>
                                  <Row><p>${formatPrice(item.price)}</p></Row>
                                </Col>
                              </Row>)
                            }
                          })}
                        </div>
                        : <></>}
                    </div>)
                  })}

                  <br></br>
                  <Row><h4>Total: ${formatPrice(cartTotal(cart))}</h4></Row>
                </Container>
              </Box>
            </Box>
          </Box>
        }

      </Box>
    </div>
  );
};

export default BilateralStepper;
